import Vue from 'vue'
import {
  Button,
  Cell,
  Tabbar,
  TabbarItem,
  Icon,
  Empty,
  Swipe,
  SwipeItem,
  Calendar,
  Search,
  DropdownMenu,
  DropdownItem,
  ActionSheet,
  List,
  Toast,
  PullRefresh,
  ImagePreview,
  SwipeCell,
  Checkbox,
  Form,
  Dialog,
  Rate,
  Field,
  CountDown,
  Switch,
  Radio,
  RadioGroup,
  CheckboxGroup,
  Progress,
  Popup,
  Loading,
  Slider,
  Grid,
  GridItem,
  Tab,
  Tabs
} from 'vant'
Vue.use(Button)
Vue.use(Cell)
Vue.use(List)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Empty)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Calendar)
Vue.use(Search)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(ActionSheet)
Vue.use(Field)
Vue.use(Toast)
Vue.use(PullRefresh)
Vue.use(ImagePreview)
Vue.use(SwipeCell)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Rate)
Vue.use(CountDown)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Progress)
Vue.use(Popup)
Vue.use(Loading)
Vue.use(Slider)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.prototype.$Toast = Toast
Vue.prototype.$ImagePreview = ImagePreview
Vue.prototype.$dialog = Dialog
